import * as api from "Api";
import * as actions from "Actions";

export const fetchTimeSheet = () => {
  return (dispatch, getState) => {
    const { currentOrganization, partner } = getState().auth;
    const combination = getState()
      .timeSheet.combination.filter(item => item.visible === true)
      .map(item => item.id);
    const {
      periodUnit,
      periods,
      collaborator,
      client,
      clientGroup,
      searchWord,
      type
    } = getState().timeSheetTree.filter;
    const {
      filter: { clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;
    dispatch(
      actions.fetchTimeSheetTree(
        api
          .getTimeSheetTree(
            currentOrganization.id,
            partner,
            combination,
            client.selected,
            clientGroup.selected,
            collaborator.selected,
            type.selected,
            periodUnit.selected,
            periods.selected,
            searchWord.searchWord,
            clientCRMTypes,
            clientCRMGroup,
            deletedStatus
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const saveTimeSheet = forcedImport => {
  return (dispatch, getState) => {
    const { sourceModel, timeSheetAttachment } = getState().timeSheet;
    const { currentOrganization } = getState().auth;

    return dispatch(
      actions.saveTimeSheet(
        api.importTimeSheet({
          config: JSON.stringify({ model: sourceModel }),
          timeSheetAttachment,
          forcedImport,
          data: currentOrganization.id
        })
      )
    );
  };
};

export const exportPeriodTimeSheet = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const combination = getState()
      .timeSheet.combination.filter(item => item.visible === true)
      .map(item => item.id);
    const {
      periodUnit,
      periods,
      collaborator,
      client,
      clientGroup,
      searchWord,
      type
    } = getState().timeSheetTree.filter;
    const {
      filter: { clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;
    dispatch(
      actions.exportPeriodTimeSheet(
        api.exportPeriodTimeSheet(
          currentOrganization.id,
          combination,
          client.selected,
          clientGroup.selected,
          collaborator.selected,
          type.selected,
          periodUnit.selected,
          periods.selected,
          searchWord.searchWord,
          clientCRMTypes,
          clientCRMGroup,
          deletedStatus
        )
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/time-sheet.js